export const PLATFORM_NAMES = [
  "Review Platform Data",
  "Forum Data",
  "Instagram Twitter TikTok Data",
  "Linkedin Facebook Data",
  "China Data",
];
